var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"mb-0"},[_vm._v("\n  "+_vm._s(_vm.product.name)+"\n  "),_c('span',{class:{ 'text-reset': !_vm.nowrap, 'd-block': !_vm.nowrap }},[_vm._v("Pro-Install")])])}
var staticRenderFns = []

export { render, staticRenderFns }